export default __webpack_public_path__ + "static/media/vbrn.e046cc3c.png";